import { render } from "./SaveSemesterChangedModal.vue?vue&type=template&id=02e081a8"
import script from "./SaveSemesterChangedModal.vue?vue&type=script&lang=js"
export * from "./SaveSemesterChangedModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__